import { ProductProcessingStatus } from '@/constants/productProcessingType'
import type { Product } from '@/types/product'
import ApiClient from '@/utils/apiClient'

import type { AxiosResponse } from 'axios'

class ProductService {
  apiClient: any
  constructor() {
    this.apiClient = new ApiClient(import.meta.env.VITE_DX_API_URL)
  }

  getProducts = async (bpId: number | null, brandName: string): Promise<Product[]> => {
    const response: AxiosResponse = await this.apiClient.get(`businessProfiles/${bpId}/products`, {
      'filterGroups[0].Filters[0].Field': 'brand',
      'filterGroups[0].Filters[0].Condition': 'Equals',
      'filterGroups[0].Filters[0].Values[0]': brandName,
      'filterGroups[1].Filters[0].Field': 'FeedProcessorStatus',
      'filterGroups[1].Filters[0].Condition': 'Equals',
      'filterGroups[1].Filters[0].Values[0]': String(ProductProcessingStatus.ReadyForUpload),
    })

    interface ProductData {
      id: number
      imageLink?: string | null
      additionalImageLink?: string | null
      remBgUrls?: string
      parentCategory: string
      parentProductName: string
      weightInGrams: string
      unitOfMeasure: string
      volumeInCC: string
      metadata: string
      brand: string
    }

    const productsData: ProductData[] = response.data.products

    const products: Product[] = []

    productsData.forEach((product) => {
      const originalUrls: string[] = []
      const remBgUrls: string[] = []

      if (product.imageLink) {
        originalUrls.push(product.imageLink)
      }

      if (product.additionalImageLink) {
        try {
          const additional = JSON.parse(product.additionalImageLink)
          if (Array.isArray(additional)) {
            originalUrls.push(...additional)
          }
        } catch (err) {
          console.error('Failed to parse additionalImageLink:', err)
        }
      }

      if (product.remBgUrls) {
        try {
          const parsedRemBg = JSON.parse(product.remBgUrls)
          if (parsedRemBg.imageLink) {
            remBgUrls.push(parsedRemBg.imageLink)
          }
          if (Array.isArray(parsedRemBg.additionalImageLink)) {
            remBgUrls.push(...parsedRemBg.additionalImageLink)
          }
        } catch (err) {
          console.error('Failed to parse remBgUrls:', err)
        }
      }

      originalUrls.forEach((url, index) => {
        products.push({
          id: product.id,
          productUrl: url,
          loading: false,
          parentCategory: product.parentCategory,
          parentProductName: product.parentProductName,
          weightInGrams: product.weightInGrams,
          unitOfMeasure: product.unitOfMeasure,
          volumeInCC: product.volumeInCC,
          metaData: product.metadata,
          brand: product.brand
        })
      })
    })

    return products
  }
}

export default ProductService
